/* eslint-disable no-console */
import { initializeApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

// Decode Base64 and parse JSON
function parseFirebaseConfig(): Record<string, string> | undefined {
  const b64 = process.env.REACT_APP_FIREBASE_CONFIG_B64;
  if (!b64) {
    console.warn('Missing Firebase config');
    return undefined;
  }
  try {
    const jsonStr = Buffer.from(b64, 'base64').toString('utf-8');
    const config = JSON.parse(jsonStr);

    if (typeof config !== 'object' || config === null) {
      console.warn('Parsed Firebase config is not an object');
      return undefined;
    }

    return config;
  } catch (e) {
    console.warn(`Invalid Base64 Firebase config: ${(e as Error).message}`);
    return undefined;
  }
}

const firebaseConfig = parseFirebaseConfig();

const firebaseApp = firebaseConfig ? initializeApp(firebaseConfig) : undefined;

const firebaseAppCheck = firebaseApp
  ? initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(
        process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY ?? '',
      ),
      isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
    })
  : undefined;

export { firebaseApp, firebaseAppCheck };
